// extracted by mini-css-extract-plugin
module.exports = {"SmartImage":"SmartImage_SmartImage__d75oe","photo":"SmartImage_photo__3UWnU","placeholder":"SmartImage_placeholder__22mm_","loader":"SmartImage_loader__8eOMR"};